import { useEffect, useMemo, useRef } from "react";
import TagManager from 'react-gtm-module';
import { useSelector } from "./useApp";

const useGTM = () => {
  const { data: systemData } = useSelector(state => state.general.system);
  const initializedIds = useRef<Set<string>>(new Set());

  const gtmIds: string[] = useMemo(() => {
    if (!systemData || systemData?.length < 1) return [];
    const gtm = systemData?.find((item: any) => item?.key === 'gtm');
    if (!gtm?.content) return [];

    return String(gtm.content)
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
  }, [systemData]);

  useEffect(() => {
    gtmIds.forEach((id) => {
      if (initializedIds.current.has(id)) return;
      TagManager.initialize({ gtmId: id });
      initializedIds.current.add(id);
    });
  }, [gtmIds]);
}

export default useGTM;
